import anyToError from './anyToError'

const throwAny = e => {
  throw anyToError(e)
}

export default throwAny
